export default "__VITE_ASSET__NEY2nAHK__"